import { message } from 'antd'
import { emailOrderAcknowledgement } from '../../../HttpRequests/orders';
import { setFileList } from '../State/fileList';
import handleException from '../../../Core/Helpers/handleException';

export default (values) => async (dispatch, getState) => {

  try {

    const { id } = values;

    const data = new FormData();

    data.append('to', values.to.join(','));
    data.append('cc', values.cc.join(','));
    data.append('bcc', values.bcc.join(','));
    data.append('subject', values.subject);
    data.append('body', values.body);

    const { fileList } = getState().modals.EmailOrderAcknowledgement;

    fileList.forEach((file) => {
      data.append('files[]', file);
    });

    await emailOrderAcknowledgement({ id, data });

    message.success("Mail Queued");

    dispatch(setFileList([]));

    return true;

  } catch(error) {

    handleException(error);

    return false;
  }
}
